import {ApolloClient, gql, InMemoryCache} from "@apollo/client";
import {API_URL} from "../src/constants/constants";

const defaultOptions = {
    watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
    },
    query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    },
}

const client = new ApolloClient({
    uri: API_URL,
    cache: new InMemoryCache(),
    defaultOptions: defaultOptions,
});

export const getProjectMetaService = async (saleAddress) => {
    const projectMetaQuery = `query {
        sales(where: { address: "${saleAddress}" }) {
        id
        address
        deployBlock
        deployTimestamp
        factory {
            id
            address
            implementation
            redeemableERC20Factory
        }
        calculatePriceStateConfig {
          id
          sources
          constants
          stackLength
          argumentsLength
        }
        canStartStateConfig {
          id
          sources
          constants
          stackLength
          argumentsLength
        }
        canEndStateConfig {
          id
          sources
          constants
          stackLength
          argumentsLength
        }
        token {
          id
          deployer
          admin
          factory
          grantedReceivers
          grantedSenders
          minimumTier
          symbol
          totalSupply
          decimals
          name
          deployBlock
          deployTimestamp
          tier {
            id
          }
        }
        reserve {
          id
          deployBlock
          deployTimestamp
          symbol
          totalSupply
          decimals
          name
        }
        calculatePriceStateConfig {
          id
          sources
          constants
          stackLength
          argumentsLength
        }
        recipient
        cooldownDuration
        minimumRaise
        dustSize
        startEvent {
          id
          block
          transactionHash
          timestamp
          sender
        }
        endEvent {
          id
          block
          transactionHash
          timestamp
          sender
          saleStatus
        }
        unitsAvailable
        totalRaised
        percentRaised
        totalFees
        saleStatus
      }
    }`
    return client.query({
        query: gql`${projectMetaQuery}`
    });
}

export const salesQuery = async (saleAddress) => {
    const projectMetaQuery = `query {
        sales(where: { address: "${saleAddress}" }) {
      id
      token {
        id
        name
        symbol
        decimals
        totalSupply
        minimumTier
        tier {
          id
          __typename
        }
      }
      calculatePriceStateConfig {
        sources
        constants
      }
      reserve {
        id
        name
        symbol
        decimals
        totalSupply
      }
      cooldownDuration
      deployBlock
      saleStatus
      canStartStateConfig {
        constants
      }
      canEndStateConfig {
        constants
      }
      unitsAvailable
      minimumRaise
    }
    }`
    return client.query({
        query: gql`${projectMetaQuery}`
    });
}


